import React, { useEffect, useState } from "react";
import { message, Switch } from "antd";
import { useAdmin } from "context/adminContext";
import { useLoading } from "context/loadingContext";
import GetPermissions from "functions/admin/getPermissions";
import GetMerchantPermissions from "functions/merchant/getMerchantPermissions";
import UndoMerchantPermission from "functions/merchant/undoMerchantPermission";
import SetMerchantPermission from "functions/merchant/setMerchantPermission";
import { bg_shadow } from "constant/css";

const MerchantPermission = () => {
  const { activeMerchantId } = useAdmin();
  const { showLoading, hideLoading } = useLoading();
  const [permissions, setPermissions] = useState([]);
  const xpayPermissions = permissions.filter((e) => e.type === "xpay");
  const billingPermissions = permissions.filter((e) => e.type === "billing");
  useEffect(() => {
    if (activeMerchantId) fetchPermissions();
  }, [activeMerchantId]);

  const fetchPermissions = async () => {
    showLoading();
    try {
      const response = await GetPermissions();
      console.log("Permissions response:", response);
      if (response) {
        setPermissions(response.data);
        fetchMerchantPermissions();
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    } finally {
      hideLoading();
    }
  };

  const fetchMerchantPermissions = async () => {
    showLoading();
    try {
      const response = await GetMerchantPermissions(activeMerchantId);
      if (response) {
        console.log("Merchant permissions response:", response);
        setPermissions((prev) =>
          prev.map((item) => {
            const merchantPermission = response.data.find(
              (perm) => perm.id === item.id
            );
            return {
              ...item,
              checked: merchantPermission ? true : false,
            };
          })
        );
      } else message.error("No permissions found for this merchant.");
    } catch (error) {
      message.error("Error fetching merchant permissions:");
    } finally {
      hideLoading();
    }
    hideLoading();
  };

  const toggle = async (id) => {
    //toggle by id
    setPermissions((prev) =>
      prev.map((item) => (item.id === id ? { ...item, loading: true } : item))
    );
    const updatingPermission = permissions.find((e) => e.id === id);
    const done = () => {
      setPermissions((prev) =>
        prev.map((item) =>
          item.id === id
            ? { ...item, checked: !item.checked, loading: false }
            : item
        )
      );
      message.success(`${updatingPermission.name} тохируулагдлаа`);
    };
    if (updatingPermission.checked) {
      const response = await UndoMerchantPermission(activeMerchantId, id);
      console.log("Undo response:", response);
      if (response) done();
    } else {
      const response = await SetMerchantPermission(activeMerchantId, id);
      if (response) done();
    }

    // Here you would typically also send the updated permission state to the server
  };

  return (
    <div
      className={`flex flex-col md:flex-row gap-12 p-6 bg-white rounded-xl shadow ${bg_shadow}`}
    >
      {/* Left Column */}
      <div className="flex-1">
        <h2 className="font-semibold text-lg mb-4">Биллинг үйлчилгээ</h2>
        {billingPermissions.map((item) => (
          <div key={item.key} className="flex justify-between items-start py-2">
            <div className="text-sm text-gray-700">
              <div>{item.name}</div>
              <div className="text-xs text-gray-500">{item.description}</div>
            </div>
            <Switch
              checked={item.checked || false}
              onChange={() => toggle(item.id)}
              loading={item.loading || false}
              className="ml-4 mt-1"
            />
          </div>
        ))}
      </div>

      {/* Right Column */}
      <div className="flex-1">
        <h2 className="font-semibold text-lg mb-4">xPay үйлчилгээ</h2>
        {xpayPermissions.map((item) => (
          <div key={item.key} className="flex justify-between items-start py-2">
            <div className="text-sm text-gray-700">
              <div>{item.name}</div>
              <div className="text-xs text-gray-500">{item.description}</div>
            </div>
            <Switch
              checked={item.checked || false}
              loading={item.loading || false}
              onChange={() => toggle(item.id)}
              className="ml-4 mt-1"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MerchantPermission;
